const locale = {
	// #region Recycle bin fields
	RECYCLEBIN_COLUMN_TABLE: 'Item type',
	RECYCLEBIN_COLUMN_TABLE_TITLE: 'Item',
	RECYCLEBIN_COLUMN_USER: 'User',
	RECYCLEBIN_COLUMN_DATE: 'Date'
	// #endregion
};

export default locale;
